import { Component } from '@angular/core';

@Component({
    selector: 'sgt-cnae-indicador-principal-badge',
    templateUrl: './cnae-indicador-principal-badge.component.html',
    styleUrls: ['./cnae-indicador-principal-badge.component.less']
})
export class CNAEIndicadorPrincipalBadgeComponent { }
